import { post } from "./Session";
import { Token } from "./Session";
const map = new Map();

export function haspermission(permission){
        if (map.has(permission)){
            return map.get(permission);
        }
        let body = {};
        body.token = Token.get();
        body.permission = permission + "";
        let response = post(body, "/SinglePermissionRequest")
        if  (response == null){
            map.set(permission, false);
            return false;
        }else if(response == "OK.") {
            map.set(permission, true);
            return true;
        }
        return false;
    }
export function hasspartenpermission(target){
    let body = {};
    body.token = Token.get();
    body.target = target;
    body.action = "has_perm";
    console.log("DEBUG BODY " + body)
    let response = post(body,"/vergleiche/sub-sparten");
    console.log(response);
    if (response == "true"){
        return true;
    }else {
        return false;
    }
}